import { useConfigurationContext } from "@/features/configuration/contexts/configuration-context";
import { Venta } from "@/shared/types/venta";
import { StackProps } from "@mui/material";
import FacturaThemeProvider from "./factura-theme-provider";
import VentaInfoHorizontal from "./venta-info-horizontal";
import Page from "./page";
import VentaInfoVertical from "./venta-info-vertical";
import VentaInfoTicket from "./venta-info-ticket";

export interface VentaPrintProps extends StackProps {
    venta: Venta,
    variant?: "factura" | "ticket",
    monedaId?: string
}

function splitArrayIntoChunks<T = any>(array: Array<T>, chunkSize: number): Array<Array<T>> {
    if (chunkSize <= 0) return [];

    const res: T[][] = [];
    for (let i = 0; i < array.length; i += chunkSize) {
        res.push(array.slice(i, i + chunkSize));
    }
    return res;
}

export default function VentaPrint({
    venta,
    variant = "ticket",
    monedaId,
    ...props
}: VentaPrintProps) {
    const { horizontal, itemsPerPage, marginTopPx } = useConfigurationContext();

    const ventaItems = splitArrayIntoChunks(venta.items, itemsPerPage);

    const renderFactura = () => {
        //TODO: Print multiple pages if items is bigger than items per page.

        if (horizontal) {
            return ventaItems.map((chunk, i) => <Page key={i} direction={"row"} {...props}>
                <VentaInfoHorizontal marginTop={`${marginTopPx}px`} venta={venta} items={chunk} padding={3} flex={1} />
                <VentaInfoHorizontal marginTop={`${marginTopPx}px`} venta={venta} items={chunk} padding={3} flex={1} />
            </Page>)
        } else {
            return ventaItems.map((chunk, i) => <Page key={i} direction={"column"} {...props}>
                <VentaInfoVertical marginTop={`${marginTopPx}px`} venta={venta} items={chunk} padding={3} flex={1} />
                <VentaInfoVertical marginTop={`${marginTopPx}px`} venta={venta} items={chunk} padding={3} flex={1} />
            </Page>)
        }
    }

    const renderTicket = () => {
        return <Page sx={{ minHeight: "auto", width: "auto" }}>
            <VentaInfoTicket monedaId={monedaId} venta={venta} items={venta.items} />
        </Page>
    }

    return <FacturaThemeProvider>
        {variant === "factura" ? renderFactura() : renderTicket()}
    </FacturaThemeProvider>
}